import { PIPELINE } from "../../constants";

const { NEW_PIPELINE_SWIMLANES, DRAFT } = PIPELINE;

export const convertOpportunitiesIntoPipeLineData = oppoArray => {
  let pipelineData = [];
  pipelineData = NEW_PIPELINE_SWIMLANES.map(lane => {
    const tempLane = { ...lane };
    tempLane.opportunitiesByDocs = [];
    oppoArray.forEach(opportunity => {
      // Add the external quotes in pipeline data for "DRAFT" status only
      if (lane.status.includes(DRAFT)) {
        if (
          opportunity.external_quotes &&
          opportunity.external_quotes.length > 0
        ) {
          tempLane.externalQuotes = opportunity.external_quotes.map(extQt => ({
            ...extQt,
            isExternalQuotes: true,
          }));
        }
      }
      // Add the documents in pipeline data by status wise
      opportunity.docs.forEach(doc => {
        if (lane.status.includes(doc.status)) {
          const oppByDoc = { ...opportunity, docs: doc };
          tempLane.opportunitiesByDocs.push(oppByDoc);
        }
      });
    });
    return tempLane;
  });
  return pipelineData;
};

export const getOppswithAccountData = (opportunitiesData, accounts) => {
  if (opportunitiesData) {
    const accIDMap = {};
    let tempAccounts = [];
    if (accounts && accounts.length > 0) {
      tempAccounts = accounts;
    }
    // Create an account_id -> account details maps
    tempAccounts.forEach(account => {
      accIDMap[account.id] = {
        id: account.id,
        name: account.name,
        source: account.source,
        detailed_address: account.detailed_address,
      };
    });
    // Update the opportunity data with crm_account
    if (Array.isArray(opportunitiesData)) {
      opportunitiesData.forEach(opp => {
        if (accIDMap[opp.crm_account_id]) {
          opp.crm_account = accIDMap[opp.crm_account_id];
        } else {
          opp.crm_account = {};
        }
      });
    } else if (accIDMap[opportunitiesData.crm_account_id]) {
      opportunitiesData.crm_account =
        accIDMap[opportunitiesData.crm_account_id];
    } else {
      opportunitiesData.crm_account = {};
    }
    return opportunitiesData;
  }
  return [];
};
